/**
 * Separator Component
 * Simple divider element for visual separation
 */

import * as React from 'react';

export interface SeparatorProps {
  className?: string;
  orientation?: 'horizontal' | 'vertical';
}

export const Separator = React.forwardRef<HTMLDivElement, SeparatorProps>(
  ({ className = '', orientation = 'horizontal' }, ref) => {
    return (
      <div
        ref={ref}
        className={`
          ${orientation === 'horizontal' ? 'h-px w-full' : 'h-full w-px'}
          bg-slate-200
          ${className}
        `}
        role="separator"
        aria-orientation={orientation}
      />
    );
  }
);

Separator.displayName = 'Separator';
